"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

require("../../../css/ToolBar.css");

var _ToolColumn = _interopRequireDefault(require("./ToolColumn"));

var ToolBar = function ToolBar() {
  var dragUrl = _react["default"].useRef();

  var handleOnDragStart = function handleOnDragStart(e, type) {
    e.dataTransfer.setData('type', type);
    dragUrl.current = e.target.src;
  }; // If this is true, we're in App forms, so show Radio and Checkbox


  var multiCheckboxDisabled = window.pdfFormConfigObject.enableMultiCheckbox === false;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Container, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Row, null,
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      type: "signature",
      onDragStartCallback: handleOnDragStart
    }),
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      type: "text-field",
      onDragStartCallback: handleOnDragStart
    }),
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      type: "checkbox",
      onDragStartCallback: handleOnDragStart
    })),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Row, null, multiCheckboxDisabled &&
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      styleClasses: "pt-4",
      type: "radio",
      onDragStartCallback: handleOnDragStart
    }),
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      styleClasses: multiCheckboxDisabled ? 'pt-4' : 'pt-4 offset-2 no-flex-grow',
      type: "date",
      onDragStartCallback: handleOnDragStart
    }),
    /*#__PURE__*/
    _react["default"].createElement(_ToolColumn["default"], {
      styleClasses: multiCheckboxDisabled ? 'pt-4' : 'pt-4 no-flex-grow',
      type: "dropdown",
      onDragStartCallback: handleOnDragStart
    })))
  );
};

var _default = exports["default"] = ToolBar;